/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldnameplaceholder3Inputs */

const en_ticketsfieldnameplaceholder3 = /** @type {(inputs: Ticketsfieldnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Regular`)
};

const de_ticketsfieldnameplaceholder3 = /** @type {(inputs: Ticketsfieldnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Normal`)
};

/**
* | output |
* | --- |
* | "e.g. Regular" |
*
* @param {Ticketsfieldnameplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldnameplaceholder3 = /** @type {((inputs?: Ticketsfieldnameplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldnameplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldnameplaceholder3(inputs)
	return de_ticketsfieldnameplaceholder3(inputs)
});
export { ticketsfieldnameplaceholder3 as "ticketsFieldNamePlaceholder" }